import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let inflight = null;

/** Echte Bewertungs-Kennzahlen aus der DB (mit Modul-Cache) — Fallback bis geladen. */
export default function useReviewStats(fallbackCount = 180, fallbackAvg = 4.7) {
  const [stats, setStats] = useState(cache);

  useEffect(() => {
    if (cache) return undefined;
    if (!inflight) {
      inflight = axios.get(`${API}/api/reviews/stats`)
        .then(({ data }) => { cache = data; return data; })
        .catch(() => null);
    }
    let mounted = true;
    inflight.then((d) => { if (mounted && d) setStats(d); });
    return () => { mounted = false; };
  }, []);

  const count = stats?.count > 0 ? stats.count : fallbackCount;
  const avgRating = stats?.avg_rating > 0 ? stats.avg_rating : fallbackAvg;
  return { count, avgRating, avgRatingDe: String(avgRating).replace('.', ','), loaded: Boolean(stats) };
}
